const FAQ_ITEMS = [
  {
    question: '本当に動画の内容で止められませんか？',
    answer:
      '動画販売業者が扱う素材であることを理由にした、アカウント停止やファイル削除は行いません。',
  },
  {
    question: '受け取る相手も登録が必要ですか？',
    answer: '必要ありません。共有リンクを開くだけで、動画を確認・ダウンロードできます。',
  },
  {
    question: 'お試し後の動画はどうなりますか？',
    answer: '無料登録すると、アップロードした動画と共有リンクをそのまま引き継げます。',
  },
] as const

export function LandingFaq() {
  return (
    <section className="border-t border-border bg-white">
      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 sm:py-24">
        <p className="text-center text-xs font-bold uppercase tracking-[0.2em] text-primary">FAQ</p>
        <h2 className="mt-3 text-center text-2xl font-bold tracking-tight sm:text-3xl">
          よくある質問
        </h2>
        <dl className="mt-10 space-y-3">
          {FAQ_ITEMS.map((item) => (
            <div
              key={item.question}
              className="rounded-2xl border border-border bg-muted/30 p-5 sm:p-6"
            >
              <dt className="flex gap-4 font-bold">
                <span className="text-primary">Q</span>
                {item.question}
              </dt>
              <dd className="mt-3 flex gap-4 text-sm leading-relaxed text-muted-foreground">
                <span className="font-bold text-foreground">A</span>
                {item.answer}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  )
}
